import { useMemo } from 'react'

import { useAuth } from '@/context/AuthContext'
import { useToast } from '@/context/ToastContext'
import { ApiHandler } from '@/services/core/ApiHandler'
import { ApiConfig, ErrorHandlingStrategy, MessageLevel } from '@/types/api'

const DEFAULT_CONFIG: ApiConfig = {
    messageLevel: MessageLevel.ALL,
    errorHandling: ErrorHandlingStrategy.RETURN,
    timeout: 30000,
    retryAttempts: 1
}

export function useApiHandler(
    baseURL: string,
    config: Partial<ApiConfig> = {}
) {
    const { getAccessToken, getRefreshToken, getNewAccessToken, logout } =
        useAuth()
    const { showToast } = useToast()

    const apiHandler = useMemo(() => {
        const finalConfig = { ...DEFAULT_CONFIG, ...config }

        return new ApiHandler({
            baseURL,
            getAccessToken,
            getRefreshToken,
            getNewAccessToken,
            onAuthError: () => logout(),
            showMessage: showToast,
            ...finalConfig
        })
    }, [
        baseURL,
        config,
        getAccessToken,
        getRefreshToken,
        getNewAccessToken,
        logout,
        showToast
    ])

    return apiHandler
}
